import { useQueries } from 'react-query';
import { fetchProjectDataroom } from '~/api/dataroom';
import { Dataroom } from '~/types/dataroom';
import { Project } from '~/types/project';
import { getDataroomQueryKey } from './useDataroomQuery';

export interface ProjectDataroomEntry {
  project: Project;
  dataroom?: Dataroom;
  status: 'idle' | 'loading' | 'success' | 'error';
}

export const usePortfolioProjectDatarooms = (projects: Project[] | undefined): ProjectDataroomEntry[] => {
  const list = projects ?? [];
  const queries = useQueries(
    list.map(project => ({
      // Share cache with project-page useDataroomQuery so navigating into the project page is instant
      queryKey: getDataroomQueryKey('project', project.id),
      queryFn: () => fetchProjectDataroom(project.id).catch(() => undefined),
      staleTime: Infinity,
      retry: false,
    }))
  );

  return list.map((project, idx) => ({
    project,
    dataroom: queries[idx]?.data as Dataroom | undefined,
    status: queries[idx]?.status ?? 'idle',
  }));
};
